import { render } from "./search-bar.vue?vue&type=template&id=6cfa2f91&scoped=true&ts=true"
import script from "./search-bar.vue?vue&type=script&lang=ts"
export * from "./search-bar.vue?vue&type=script&lang=ts"

import "./search-bar.vue?vue&type=style&index=0&id=6cfa2f91&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfa2f91"]])

export default __exports__